export const toSecondsVal = {
  minute: 60,
  hour: 3600,
  day: 86400,
  week: 604800,
  month: 2628000,
};

export const ONE_DAY = toSecondsVal.day;
export const timeConverter = {
  m2s: (min: number) => min * toSecondsVal.minute,
  h2s: (hrs: number) => hrs * toSecondsVal.hour,
  d2s: (days: number) => days * toSecondsVal.day,
  w2s: (weeks: number) => weeks * toSecondsVal.week,
  mth2s: (mth: number) => mth * toSecondsVal.month,
};

export const timeInSeconds = {
  ...toSecondsVal,
  ...timeConverter,
};
